import Logo from '@/components/shared/Logo';
import { useI18n } from '@/lib/i18n';

export default function PageNotFound() {
    const { tx } = useI18n();

    return (
        <div className="min-h-[100dvh] flex flex-col items-center justify-center p-6 bg-background">
            <div className="max-w-sm w-full text-center space-y-6">
                <Logo />
                <div className="space-y-2">
                    <h1 className="font-display text-6xl font-bold text-muted-foreground/30">404</h1>
                    <p className="text-muted-foreground">{tx("This page doesn't exist.")}</p>
                </div>
                <button
                    onClick={() => window.location.href = '/'}
                    className="inline-flex items-center px-6 py-3 text-sm font-semibold bg-primary text-primary-foreground rounded-xl hover:opacity-90 transition-opacity"
                >
                    {tx("Go home")}
                </button>
            </div>
        </div>
    );
}
